import React, { useMemo, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { useAppSelector } from '../../../../App/Hooks/reduxHooks'
import { useKeyPress } from '../../../../Common/Hooks/useKeyPress'
import { Spinner } from '../../../../Common/Spinner'
import { ICustomer } from '../../../../Customer/interfaces/ICustomer'
import { useOutsideClick } from '../../../utils/useOutsideClick'

import { FilterDropdown } from './FilterDropdown'
import {
  InputWrapper,
  UserInput,
  UserInputCancelIcon,
  UserInputCancelSpan,
  UserInputContainer,
  UserInputIcon,
  UserInputUnderline,
  UserInputWrapper,
} from './style'

interface IProps {
  setValue: UseFormSetValue<any>
  setIsPanelFocus: (crudPanelState: boolean) => void
}

export const CustomerSearch = ({ setValue, setIsPanelFocus }: IProps) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false)
  const [filteredResults, setFilteredResults] = useState<ICustomer[]>([])
  const [searchInput, setSearchInput] = useState<string>('')

  const customerList = useAppSelector(state => state.customerNew.list)

  const isEscPress: boolean = useKeyPress('Escape')
  const tabIndex = 0

  const closeOnOutsideClick = () => {
    setIsDropdownVisible(false)
  }

  const dropdownRef = useOutsideClick(closeOnOutsideClick)

  const resetCustomerSelectField = () => {
    setSearchInput('')
    setValue('customerUuid', '')
  }

  useMemo(
    () => setIsPanelFocus(!isDropdownVisible),
    [isDropdownVisible, setIsPanelFocus],
  )
  useMemo(() => {
    if (!isEscPress) {
      return
    }
    closeOnOutsideClick()
  }, [isEscPress])

  if (!customerList) {
    return <Spinner />
  }
  const searchItems = (searchValue: string) => {
    if (customerList) {
      if (searchInput !== '') {
        const filteredData = customerList.filter(customer => {
          if (customer.customerName.indexOf(searchInput) !== -1) {
            return true
          }
          return customer.customerLastName.indexOf(searchInput) !== -1
        })
        setFilteredResults(filteredData)
        setIsDropdownVisible(true)
      } else {
        setFilteredResults(customerList)
      }
    }
    setSearchInput(searchValue)
  }

  return (
    <UserInputContainer tabIndex={tabIndex}>
      <UserInputWrapper>
        <InputWrapper>
          <span className="input-icon">
            <UserInputIcon icon="search" />
          </span>

          <UserInput
            className="input"
            type="text"
            placeholder="Search customer"
            value={searchInput}
            onChange={e => searchItems(e.target.value)}
            onClick={() => {
              setIsDropdownVisible(true)
            }}
            // TODO ON blur does not select the dropdown value
            // onBlur={() => { setVisible(false) }}
            autoFocus
          />
          <UserInputUnderline className="underline" />
        </InputWrapper>
        <UserInputCancelSpan>
          <UserInputCancelIcon
            isRender={!!searchInput}
            icon="cross"
            onClick={resetCustomerSelectField}
          />
        </UserInputCancelSpan>
      </UserInputWrapper>
      <FilterDropdown
        customerList={customerList}
        filteredResults={filteredResults}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        setValue={setValue}
        setVisible={setIsDropdownVisible}
        dropdownRef={dropdownRef}
        isVisible={isDropdownVisible}
      />
    </UserInputContainer>
  )
}
